<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" @click="getLists">搜索</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="handleAdd">新增</el-button>
				</el-form-item>
			</el-form>
		</el-col>
		<!--列表-->
		<el-table :data="datalist" border stripe highlight-current-row v-loading="listLoading" style="width:90%;" height="600">
			<el-table-column prop="entime" label="时间" min-width="100"></el-table-column>
			<el-table-column prop="type" label="编号" min-width="100"></el-table-column>
			<el-table-column prop="msgstr" label="日志" min-width="100"></el-table-column>
			<el-table-column label="操作" fixed="right" width="100">
				<template slot-scope="scope">
					<div>
						<el-button type="text" size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
						<el-button type="text" size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button>
					</div>
				</template>
			</el-table-column>
		</el-table>
		<!--工具条翻页-->
		<el-col :span="24" class="toolbar">
		<el-pagination layout="total,prev, pager, next" @current-change="handleCurrentChange" :page-size="pagesize" :total="total" style="float:right;"></el-pagination>
		</el-col>

		<!--编辑界面-->
		<el-dialog :title="editformtitle" :visible.sync="editFormVisible" :close-on-click-modal="false">
			<el-form :model="editForm" label-width="100px" :rules="formRules" ref="editForm">
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>
	</section>
</template>
<script>
	import util from '../../common/js/util'
	import { getListPage, delData, saveData } from '../../api/api';
	export default {
		data() {
			return {
				filters:{
				},
				datalist: [],
				total: 0,
				pagesize:20,
				page: 1,
				listLoading: false,
				/////////////Form 表单
				editformtitle:'',//form编辑名称
				editFormVisible: false,//编辑界面是否显示
				editLoading: false,
				formRules: {
				},
				//编辑界面数据
				editForm: {
					actionurl:'',sqlid:'',entime:'',type:'',msgstr:''
				}
			}
		},
		methods: {
			getLists:function(){
				let para = {
					page: this.page,
					pagesize:this.pagesize,
					actionurl:'default/getList',
					sqlid:'html_log.query'
				};
				this.listLoading = true;
				getListPage(para).then((res) => {
					if(!util.checkLogOut(this,res.data)){
						this.total = res.data.total;
						this.datalist = res.data.datas;
					}
					this.listLoading = false;
				});
			},
			handleAdd:function(){
				this.editFormVisible = true;
				this.editformtitle = '新增';
				this.editForm = {
					actionurl:'default/save',sqlid:'html_log.add',entime:'',type:'',msgstr:''
				};
			},
			handleEdit: function (index, row) {
				this.editFormVisible = true;
				this.editformtitle = '编辑';
				this.editForm = Object.assign({}, row);
				this.editForm.actionurl = 'default/save';//设置Sqlid
				this.editForm.sqlid = 'html_log.upt';
			},
			editSubmit:function(){
				let para = Object.assign({}, this.editForm);
				util.saveFunction(this,para);
			},
			handleDel: function (index, row) {
				this.$confirm('确认删除该记录吗?', '提示', {type: 'warning'}).then(() => {
					this.listLoading = true;
					let para = {
						actionurl:'default/del',
						sqlid:'html_log.del',
						id:row.id
					};
					delData(para).then((res) => {
						this.listLoading = false;
						this.$message({message: res.data.message,type: res.data.type});
						this.getLists();
					});
				}).catch(() => {});
			}
		},
		mounted() {
			this.getLists();
		}
	}	
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// htmlLog.vue?2c434f32